//noinspection JSUnusedGlobalSymbols
export default {

    install(Vue) {

        const int  = () => Math.round(Math.random() * (122 - 97) + 97)
        const char = () => String.fromCharCode(int())

        Vue.prototype.$rndId = () => new Array(8).fill(true).map(char).join('')

    }

}
